import { render, staticRenderFns } from "./CounterComponent.vue?vue&type=template&id=135a8df0&"
import script from "./CounterComponent.vue?vue&type=script&lang=ts&"
export * from "./CounterComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CounterComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports